import LogoutIcon from '@mui/icons-material/Logout';
import { Box, IconButton, Tooltip } from '@mui/material';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { images } from '../../../../shared/lib/assets';
import { MENU_ITEM_LOGOUT } from '../../../../shared/lib/constants';
import { AuthContainerProps } from '../../../../shared/lib/interfaceTypes';
import { LINKS } from '../../app/constants';
import { useAppContext } from '../../app/contexts/AppContext';
import { StepperAppBar } from '../StepperAppBar';
import { OnBoardingSideBar } from '../common/OnBoardingSideBar';
import { AuthLogo } from './AuthLogo';
import { onBoardingMobile } from '../../../../shared/lib/theme/styleConstants';
import { handleLogout } from '../../app/utils';
import { useMobileView } from '../../app/hooks/useMobileView';

export const AuthContainer: FC<AuthContainerProps> = ({ children, onBoarding }): JSX.Element => {
  const mediumViewport = useMobileView();
  const navigate = useNavigate();
  const { MOBILE_AUTH_LOGO } = images;
  const { setIsAppUserLoggedIn, setCurrentUser } = useAppContext();

  const logout = async () => {
    await handleLogout();
    setIsAppUserLoggedIn(false);
    setCurrentUser(null);
    navigate(LINKS.LOGIN_LINK);
  };

  return (
    <Box height="100vh" p={1}>
      <Box display="flex" flexDirection={mediumViewport ? 'column' : 'row'} justifyContent="center" height={mediumViewport ? 'auto' : '100%'}>
        {onBoarding ? (
          <>
            {mediumViewport ? (
              <Box sx={onBoardingMobile}>
                <StepperAppBar />
              </Box>
            ) : (
              <OnBoardingSideBar />
            )}
          </>
        ) : mediumViewport ? (
          <Box textAlign="center" mb={2} mt={3}>
            <Box  width="98.006px" height="105.457px" component="img" src={MOBILE_AUTH_LOGO as unknown as string} alt="Mobile auth logo" />
          </Box>
        ) : (
          <AuthLogo />
        )}

        {onBoarding && !mediumViewport && (
          <Tooltip title={MENU_ITEM_LOGOUT}>
            <IconButton onClick={logout} sx={{ position: 'absolute', right: '10px', zIndex: '999' }}>
              <LogoutIcon />
            </IconButton>
          </Tooltip>
        )}

        {children}
      </Box>
    </Box>
  );
};
